import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
//import { Observable } from 'rxjs';
import { ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';

import { MatFormField } from '@angular/material/form-field';
//import { MatFormFieldModule } from '@angular/material/form-field';
//import { MatButtonModule } from '@angular/material/button';



import { MatLegacyInputModule as MatInputModule }  from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { TopBarComponent } from './top-bar/top-bar.component';
import { ProductListComponent } from './product-list/product-list.component';
import { DialogBuySuccess } from './product-details/product-details.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { BasketService } from './basket.service';
import { BasketComponent } from './basket/basket.component';
import { ShippingComponent } from './shipping/shipping.component';
import { PurchaseComponent } from './purchase/purchase.component';
import {MatIconModule} from '@angular/material/icon';
import { SuccessComponent } from './success/success.component';
import { CancelComponent } from './cancel/cancel.component';

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        ReactiveFormsModule,
        RouterModule.forRoot([
            { path: '', component: ProductListComponent },
            { path: 'products/:productId', component: ProductDetailsComponent },
            { path: 'basket', component: BasketComponent },
            { path: 'shipping', component: ShippingComponent },
            { path: 'purchase', component: PurchaseComponent },
            { path: 'cancel', component: CancelComponent },
            { path: 'success', component: SuccessComponent },
        ], {}),
        MatBadgeModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        BrowserAnimationsModule,
        MatIconModule,
    ],
    declarations: [
        AppComponent,
        TopBarComponent,
        ProductListComponent,
        ProductDetailsComponent,
        BasketComponent,
        ShippingComponent,
        PurchaseComponent,
        DialogBuySuccess,
        SuccessComponent,
        CancelComponent,
    ],
    bootstrap: [AppComponent],
    providers: [BasketService]
})
export class AppModule { }


/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/